import classNames from 'classnames';
import * as React from 'react';

import { DataAttributes } from '../../../../../../app/shared/common';

export interface ITab {
  name: string;
  id: string;
  isSelected: boolean;
  panelId: string;
}

interface TabProps extends ITab, DataAttributes {
  children: React.ReactNode;
  onClick: (name: string) => void;
  className?: string;
  selectedTabClassName?: string;
}

const Tab = React.forwardRef<HTMLAnchorElement, TabProps>(
  ({ children, className, id, isSelected, name, onClick, panelId, selectedTabClassName, ...props }, ref) => {
    const handleClick: React.MouseEventHandler<HTMLAnchorElement> = (event) => {
      event.preventDefault();
      onClick(name);
    };

    return (
      <a
        ref={ref}
        role="tab"
        id={id}
        className={classNames(className, { [selectedTabClassName]: isSelected })}
        href={`#${panelId}`}
        aria-selected={isSelected}
        onClick={handleClick}
        tabIndex={isSelected ? 0 : -1}
        {...props}
      >
        {children}
      </a>
    );
  },
);

export default Tab;
